export default {
  routes: [
    {
      name: 'hazards',
      path: '/directory/hazards',
      component: () => import('./views/TheHazards.vue'),

    },

    {
      name: 'hazard',
      path: '/directory/hazards/:uuid',
      component: () => import('./views/TheHazard.vue'),
    },
  ]
}
